var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95312 4.10148C7.58006 1.48704 11.6188 0.921167 14.8633 2.71476C18.1112 4.51044 19.7803 8.23761 18.957 11.8564C18.1335 15.4754 15.015 18.1138 11.3096 18.3271C7.60445 18.5401 4.2051 16.2775 2.97168 12.7773C2.81874 12.3432 3.04638 11.8667 3.48047 11.7138C3.91435 11.561 4.38984 11.7889 4.54297 12.2226C5.5296 15.023 8.24965 16.8335 11.2139 16.663C14.1782 16.4924 16.6731 14.3824 17.332 11.4872C17.9909 8.59199 16.6553 5.60932 14.0566 4.17277C11.458 2.73631 8.22242 3.19219 6.12109 5.28996C6.11519 5.29585 6.10862 5.30182 6.10254 5.30754L3.72754 7.49992H6.66602C7.12598 7.5001 7.49882 7.87297 7.49902 8.33293C7.49902 8.79306 7.1261 9.16674 6.66602 9.16691H1.66602C1.20578 9.16691 0.832031 8.79316 0.832031 8.33293V3.33293C0.832233 2.87286 1.2059 2.49992 1.66602 2.49992C2.12598 2.5001 2.49882 2.87297 2.49902 3.33293V6.36613L4.95312 4.10148ZM9.99902 4.99992C10.4591 4.99992 10.8318 5.37289 10.832 5.83293V10.4882L13.0879 12.7441C13.4133 13.0695 13.4133 13.5973 13.0879 13.9228C12.7625 14.2478 12.2355 14.2478 11.9102 13.9228L9.41016 11.4228C9.25388 11.2665 9.16602 11.0539 9.16602 10.8329V5.83293C9.16625 5.37289 9.53893 4.99992 9.99902 4.99992Z",
    fill: "#192839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/ActivityIcon.e9526cd6476e0fe0d711f48fea31f536.svg";
export { ForwardRef as ReactComponent };